import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Pagination, Stack } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LISTER_LAYOUT_ID } from '../../constants/DOMElementsConstants';
import { urlActions } from '../../redux/url/actions/UrlActions.creators';
import { makeGetUrlQueryInformationState } from '../../redux/url/selectors/UrlSelectors';
import { generateRelatedProductPageLinks } from '../../util/MetaLinkUtil';
import { ScrollUtil } from '../../util/ScrollUtil';
export const ListerPagination = ({ totalPages, updateCanonicalLinkElement = true }) => {
    const { canonicalUrl } = useAemConfig();
    const queryInformation = useSelector(makeGetUrlQueryInformationState());
    const dispatch = useDispatch();
    const onPageChangeHandler = (newPage) => {
        dispatch(urlActions.updatePage(newPage));
        ScrollUtil.scrollToElement(document.getElementById(LISTER_LAYOUT_ID));
    };
    useEffect(() => {
        generateRelatedProductPageLinks(canonicalUrl, queryInformation.page, queryInformation.size, totalPages, updateCanonicalLinkElement);
    }, [queryInformation.page, queryInformation.size, totalPages]);
    if (totalPages <= 1)
        return null;
    return (_jsx(Stack, { justify: "center", children: _jsx(Pagination, { baseUrl: canonicalUrl, currentPage: queryInformation.page, onPageChange: onPageChangeHandler, totalPages: totalPages }) }));
};
